module.exports = __webpack_public_path__ + "static/media/noDataAvailableForFilters.c8719407.png";